export default {
  data() {
    return {
      dialog: false,
      languages: [
        {
          text: 'Русский',
          value: 'ru',
        },
        {
          text: 'English',
          value: 'en',
        },
        {
          text: 'Украинский',
          value: 'uk',
        },
        {
          text: 'Казахский',
          value: 'kk',
        },
        {
          text: 'Испанский',
          value: 'es',
        },
      ],
      locale: this.$route.query.locale || 'ru',
      name: '',
      date: '',
      code: '',
    }
  },

  methods: {
    getLocalValue(val) {
      if (val === '') {
        return ''
      }
      const obj = JSON.parse(val)
      return obj[this.locale]
    },
    getMultiTextValue(val, local) {
      if (val === '') {
        return ''
      }
      const obj = JSON.parse(val)
      return obj[local]
    },
    getAllLocalValue(val) {
      if (val === '') {
        return ''
      }
      let res = ''
      for (const language of this.languages) {
        const obj = JSON.parse(val)
        res += obj[language.value] + '<br/>'
      }
      return res
    },
    onNameChanged(val) {
      this.name = val
    },
    onDateChanged(val) {
      this.date = val
    },
    onCodeChanged(val) {
      this.code = val
    },
    async onLanguageChanged(val) {
      this.locale = val
      await this.$router.push({
        query: {
          locale: val,
        },
      })
    },
  },
  watch: {
    async $route(to, from) {
      if (to.query.locale) {
        this.locale = to.query.locale
        await this.$apollo.queries.events.refetch()
      }
    },
  },
}
